import { motion } from 'framer-motion';
import { dpsTheme } from '../../styles/dpsTheme';

interface NavigationProps {
  currentStep: number;
  onPrevious: () => void;
  onNext: () => void;
  isValid: boolean;
}

export default function Navigation({ currentStep, onPrevious, onNext, isValid }: NavigationProps) {
  return (
    <div style={{
      marginTop: dpsTheme.spacing['3xl'],
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: dpsTheme.spacing['2xl'],
      borderTop: `1px solid ${dpsTheme.colors.border.secondary}`
    }}>
      {currentStep > 1 ? (
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          type="button"
          onClick={onPrevious}
          style={{
            padding: `${dpsTheme.spacing.md} ${dpsTheme.spacing.xl}`,
            borderRadius: dpsTheme.borderRadius.sm,
            border: `1px solid ${dpsTheme.colors.border.primary}`,
            background: dpsTheme.colors.background.darker,
            color: dpsTheme.colors.text.secondary,
            fontSize: dpsTheme.typography.fontSize.base,
            fontWeight: dpsTheme.typography.fontWeight.semibold,
            cursor: 'pointer',
            transition: 'all 0.2s',
            display: 'flex',
            alignItems: 'center',
            gap: dpsTheme.spacing.sm
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = dpsTheme.colors.background.card;
            e.currentTarget.style.borderColor = dpsTheme.colors.border.hover;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = dpsTheme.colors.background.darker;
            e.currentTarget.style.borderColor = dpsTheme.colors.border.primary;
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Précédent
        </motion.button>
      ) : (
        <div />
      )}
      <motion.button
        whileHover={{ scale: isValid ? 1.02 : 1 }}
        whileTap={{ scale: isValid ? 0.98 : 1 }}
        type="button"
        onClick={onNext}
        disabled={!isValid}
        style={{
          padding: `${dpsTheme.spacing.md} ${dpsTheme.spacing.xl}`,
          borderRadius: dpsTheme.borderRadius.sm,
          border: `1px solid ${isValid ? dpsTheme.colors.accent.blue.primary : dpsTheme.colors.border.primary}`,
          background: isValid ? dpsTheme.colors.accent.blue.gradient : dpsTheme.colors.background.darker,
          color: isValid ? '#ffffff' : dpsTheme.colors.text.disabled,
          fontSize: dpsTheme.typography.fontSize.base,
          fontWeight: dpsTheme.typography.fontWeight.bold,
          cursor: isValid ? 'pointer' : 'not-allowed',
          transition: 'all 0.2s',
          opacity: isValid ? 1 : 0.5,
          boxShadow: isValid ? dpsTheme.shadows.button : 'none',
          display: 'flex',
          alignItems: 'center',
          gap: dpsTheme.spacing.sm
        }}
        onMouseEnter={(e) => {
          if (isValid) {
            e.currentTarget.style.boxShadow = dpsTheme.shadows.hover;
          }
        }}
        onMouseLeave={(e) => {
          if (isValid) {
            e.currentTarget.style.boxShadow = dpsTheme.shadows.button;
          }
        }}
      >
        {currentStep === 3 ? 'Voir les résultats' : 'Suivant'}
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M5 12h14M12 5l7 7-7 7" />
        </svg>
      </motion.button>
    </div>
  );
}